// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"a47c0de3","687":"ec8019fc"}[chunkId] + ".chunk.js";
};